// extracted by mini-css-extract-plugin
module.exports = {"root":"TrafficLocations_root_dI1BR"};